import { Link } from 'react-router-dom'
import { getIntegrationDisplayName, IntegrationServiceId } from './integrations'
import { useIntegrationRequirement } from './useIntegrationRequirement'

interface IntegrationRequirementMessageProps {
  serviceId: IntegrationServiceId
  isTooltip?: boolean
}

export const IntegrationRequirementMessage: React.FC<IntegrationRequirementMessageProps> = ({ serviceId, isTooltip }) => {
  const checkRequirement = useIntegrationRequirement()
  const { satisfied, accountAllowed } = checkRequirement(serviceId)
  const displayName = getIntegrationDisplayName(serviceId)

  if (satisfied) {
    return null
  }

  if (!accountAllowed) {
    return <>{displayName} isn&apos;t available for your account</>
  }

  return (
    <span className='paragraph-small text-start d-block'>
      To enable Zocks to join your {displayName} meetings, connect to {displayName} in{' '}
      <Link to={`/account/integration-settings/${serviceId}`} className={isTooltip ? 'fw-bold text-white text-decoration-none' : undefined}>
        Integrations
      </Link>
      .
    </span>
  )
}
